import React, { useState, useEffect, useRef } from "react";
import "./HeroInner.css";

function HeroInner({ title, subtitle, bg }) {
  // Estado original de tu imagen
  const [loaded, setLoaded] = useState(false);
  // Nuevos estados para el video
  const [hasInteracted, setHasInteracted] = useState(false);
  const videoRef = useRef(null);

  // 1. Tu lógica original para cargar la imagen de fondo suavemente
  useEffect(() => {
    const img = new Image();
    img.src = bg;
    img.onload = () => {
      setLoaded(true);
    };
  }, [bg]);

  // 2. Nueva lógica: Detectar interacción del usuario (optimización WPO)
  useEffect(() => {
    const handleInteraction = () => {
      if (!hasInteracted) {
        setHasInteracted(true);
      }
    };

    window.addEventListener("scroll", handleInteraction, { passive: true, once: true });
    window.addEventListener("mousemove", handleInteraction, { passive: true, once: true });
    window.addEventListener("touchstart", handleInteraction, { passive: true, once: true });
    window.addEventListener("click", handleInteraction, { passive: true, once: true });

    return () => {
      window.removeEventListener("scroll", handleInteraction);
      window.removeEventListener("mousemove", handleInteraction);
      window.removeEventListener("touchstart", handleInteraction);
      window.removeEventListener("click", handleInteraction);
    };
  }, [hasInteracted]);

  // 3. Reproducir video cuando se detecta la interacción
  useEffect(() => {
    if (hasInteracted && videoRef.current) {
      videoRef.current.load();
      videoRef.current.play().catch(err => console.log("Autoplay bloqueado:", err));
    }
  }, [hasInteracted]);

  return (
	<section
      className={`hero-inner ${loaded ? "loaded" : ""}`}
      style={{
        backgroundImage: loaded ? `url(${bg})` : "none",
        backgroundSize: 'cover',
        backgroundPosition: 'bottom center', 
        position: 'relative', 
        overflow: 'hidden'
      }}
    >
      {/* El video que se carga en diferido (lazy load) */}
      <video
        ref={videoRef}
        className={`hero-video ${hasInteracted ? 'visible' : ''}`}
        autoPlay
        loop
        muted
        playsInline
      >
        {/* Solo inyectamos el origen del video si el usuario interactuó */}
        {hasInteracted && (
          <source src="/juancarlosmancharamos.webm" type="video/webm" />
        )}
      </video>

      {/* Tu capa original de textos */}
      <div className="hero-overlay" style={{ position: 'relative', zIndex: 2 }}>
        <h1>{title}</h1>
        <p>{subtitle}</p>
      </div>
    </section>
  );
}

export default HeroInner;